import { Trash2, X } from "lucide-react";

import { Button } from "@components/button/button";
import { SpinnerSimple } from "@components/spinner-simple/spinner-simple";

type IExcludeItem = {
  data: any;
  isPending: boolean;
  titleModal: string;
  subTitleModal: string;
  descModal: string;
  handleToggleCreateActvityModal: () => void;
  handleOnSubmit: (data: any) => void;
};

export function ExcludeItem({
  data,
  isPending,
  titleModal,
  subTitleModal,
  descModal,
  handleToggleCreateActvityModal,
  handleOnSubmit,
}: IExcludeItem) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60">
      <div className="relative w-full max-w-md space-y-5 rounded-lg bg-white p-6 shadow-lg">
        <div className="flex justify-between">
          <h3 className="flex text-left text-lg font-semibold text-gray-800">
            <Trash2 className="mr-2" /> {titleModal ?? "Confirmar exclusão?"}
          </h3>

          {/* Botão de fechar no topo direito */}
          <button
            onClick={handleToggleCreateActvityModal}
            className="absolute right-3 text-gray-500 hover:text-gray-800"
            aria-label="Fechar modal"
          >
            <X size={20} />
          </button>
        </div>
        <p className="text-left text-sm text-gray-600">
          {subTitleModal ?? "Você tem certeza de que deseja excluir"}{" "}
          <strong className="text-orange-500">{data?.nome}</strong>
          ?<br />
          {descModal ?? " Ele não poderá mais acessar o sistema até ser reativado."}
        </p>

        <div className="mt-4 flex w-full justify-between gap-4">
          <Button
            disabled={isPending}
            variant="secondary"
            className="w-full rounded-md bg-gray-200 px-4 py-2 text-gray-700 hover:bg-gray-300"
            onClick={handleToggleCreateActvityModal}
          >
            Cancelar
          </Button>
          <Button
            disabled={data?.situacao === "cancelada"}
            variant="default"
            className={`w-full px-4 py-2 text-white ${"bg-primary text-primary-foreground hover:bg-primary/90"}`}
            onClick={handleOnSubmit}
          >
            {isPending ? <SpinnerSimple /> : "Inativar"}
          </Button>
        </div>
      </div>
    </div>
  );
}
